import { useState } from "react";
import { useDispatch } from "react-redux";
import { addShift } from "../../stores/member/memberActions";
import Modal from "../Modal";
import i18n from "../../utils/i18n";
import CopyShiftForm from "./CopyShiftForm";

const CopyShiftButton = ({ shift, event }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const handleClick = () => {
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (newShiftData) => {
    const copiedShift = {
      ...newShiftData,
      attendance_limit: shift.attendance_limit,
      meeting_point: shift.meeting_point,
      members: shift.members,
      preferred_members: [],
      day_evening: shift.day_evening,
      before_after: shift.before_after,
    };

    if (shift.hasOwnProperty("name")) {
      copiedShift.name = shift.name;
    }

    dispatch(addShift(copiedShift));
    hideModal();
  };

  return (
    <span>
      <button
        type="button"
        onClick={handleClick}
        className="btn btn-white btn-block btn-xs copy_shift_button"
      >
        {i18n.t("schedule.shifts.copy_shift")}
      </button>
      <Modal
        show={showModal}
        onHide={hideModal}
        title={i18n.t("schedule.shifts.copy_shift")}
      >
        <CopyShiftForm
          onSubmitHandler={handleSubmit}
          event={event}
          shift={shift}
          hideModal={hideModal}
        />
      </Modal>
    </span>
  );
};

export default CopyShiftButton;

